import { ChevronDown } from "lucide-react";

export const Faq = ({ qas, testPrefix = "faq" }) => (
  <div className="divide-y divide-slate-200 border-y border-slate-200">
    {qas.map(([q, a], i) => (
      <details key={q} className="group py-5" data-testid={`${testPrefix}-item-${i}`}>
        <summary className="flex cursor-pointer items-center justify-between gap-4 list-none font-display text-base sm:text-lg font-bold text-slate-900 [&::-webkit-details-marker]:hidden">
          {q}
          <ChevronDown size={18} className="shrink-0 text-emerald-600 transition-transform duration-300 group-open:rotate-180" />
        </summary>
        <p className="mt-3 max-w-3xl text-base leading-relaxed text-slate-600">{a}</p>
      </details>
    ))}
  </div>
);
